var initProjects = function() {
    if ($('.swiper-container').length) {
        var slidr = new Swiper ('.swiper-container', {
            slidesPerView: 1,
            preloadImages: false,
            lazy: { loadPrevNext: true },
            loop: true,
            effect: 'fade',
            navigation: {
                nextEl: '.js-next',
                prevEl: '.js-prev',
            }
        });

        $('.js-dot').click(function(){
            slidr.slideTo($(this).index() +1);
        });
        slidr.on('slideChange', function(e) {
            // Dots active
            $('.js-dot').removeClass('is-active');
            var index = slidr.realIndex +1;
            $('.js-dot:nth-child('+ index +')').addClass('is-active');
        });
    }
};
initProjects();
